import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Photobooks from './pages/Photobooks';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { LanguageProvider } from './context/LanguageContext';
import ProductDetail from './pages/ProductDetail';
import OrderForm from './pages/OrderForm';
import OrderSuccess from './pages/OrderSuccess';
import OrderCancel from './pages/OrderCancel';
import OrderImages from './pages/OrderImages';
import UploadProduct from './pages/UploadProduct';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import About from './pages/About';
import Contact from './pages/Contact';
import { PhotoBookDesigner } from './components/PhotoBook';
import MobileUploadPage from './pages/MobileUploadPage';
import './App.css';

import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import OrderDetailPage from './pages/OrderDetailPage';
import ProductsAdmin from './pages/ProductsAdmin';
import AddProduct from './pages/AddProduct';
import EditProduct from './pages/EditProduct';
import Discounts from './pages/Discounts';
import StickersAdmin from './pages/StickersAdmin';

function App() {
  return (
    <LanguageProvider>
    <CartProvider>
    <WishlistProvider>
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/photobooks" element={<Photobooks />} />
          <Route path="/shporta" element={<Cart />} />
          <Route path="/te-preferuarat" element={<Wishlist />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/order" element={<OrderForm />} />
          <Route path="/order-success" element={<OrderSuccess />} />
          <Route path="/order-cancel" element={<OrderCancel />} />
          <Route path="/order-images" element={<OrderImages />} />
          <Route path="/UploadProduct" element={<UploadProduct />} />
          <Route path="/design/:id" element={<PhotoBookDesigner />} />
          <Route path="/mobile-upload/:sessionId" element={<MobileUploadPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dashboard/sign-in" element={<SignIn />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/order/:id" element={<OrderDetailPage />} />
          <Route path="/dashboard/products" element={<ProductsAdmin />} />
          <Route path="/dashboard/products/add" element={<AddProduct />} />
          <Route path="/dashboard/products/edit/:id" element={<EditProduct />} />
          <Route path="/dashboard/discounts" element={<Discounts />} />
          <Route path="/dashboard/stickers" element={<StickersAdmin />} />
          <Route path="/dashboard/stickers/:categoryId" element={<StickersAdmin />} />
        </Routes>
      </div>
    </Router>
    </WishlistProvider>
    </CartProvider>
    </LanguageProvider>
  );
}

export default App;
